import React, { FC } from 'react';
import { Col, Row, Tabs, Typography } from 'antd';

import EnvironmentSelect from '@lib/components/env-select';

import { useRecoveryAccountContext } from './components/context';
import FindByUserId from './components/find-by-userid';
import FindByUsername from './components/find-by-username';
import RecoveryAccount from './components/recovery-account';

const { Text } = Typography;

const RecoveryAccountPageBody: FC = () => {
  const { environment, setEnvironment } = useRecoveryAccountContext();

  return (
    <div className="flex flex-col flex-1 max-h-full min-h-full p-4">
      <Row gutter={16} className="mb-4">
        <Col>
          <Text className="mr-2">Environment</Text>
          <EnvironmentSelect value={environment} style={{ width: 200 }} onChange={setEnvironment} />
        </Col>
      </Row>
      <Tabs defaultActiveKey="findByUserId">
        <Tabs.TabPane key="findByUserId" tab="Find By User ID">
          <FindByUserId />
        </Tabs.TabPane>
        <Tabs.TabPane key="findByUsername" tab="Find By Username">
          <FindByUsername />
        </Tabs.TabPane>
        <Tabs.TabPane key="recoveryAccount" tab="Recovery Account">
          <RecoveryAccount />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default RecoveryAccountPageBody;
